/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ToggleIGO: BridgeCommands.Command<
    Types.Nvapp.Nvigoutil.ToggleIGOParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'ToggleIGO',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetShadowPlaySupported: BridgeCommands.Command<
    Types.Nvapp.Nvigoutil.GetShadowPlaySupportedParameters,
    Types.Nvapp.Nvigoutil.GetShadowPlaySupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'GetShadowPlaySupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetShadowPlayStatus: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvigoutil.GetShadowPlayStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'GetShadowPlayStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFilterPhotoModeState: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvigoutil.GetFilterPhotoModeStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'GetFilterPhotoModeState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetFilterPhotoMode: BridgeCommands.Command<
    Types.Nvapp.Nvigoutil.SetFilterPhotoModeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'SetFilterPhotoMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetGAssistInstall: BridgeCommands.Command<
    Types.Nvapp.Nvigoutil.SetGAssistInstallParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'SetGAssistInstall',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OpenIGO: BridgeCommands.Command<
    Types.Nvapp.Nvigoutil.OpenIGOParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'OpenIGO',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHotkeyShortcut: BridgeCommands.Command<
    Types.Nvapp.Nvigoutil.GetHotkeyShortcutParameters,
    Types.Nvapp.Nvigoutil.GetHotkeyShortcutReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'GetHotkeyShortcut',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetNvAppReadyForGAssist: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvigoutil.SetNvAppReadyForGAssistReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'SetNvAppReadyForGAssist',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ToggleMcpServer: BridgeCommands.Command<
    Types.Nvapp.Nvigoutil.ToggleMcpServerParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'ToggleMcpServer',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMcpServerStatus: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvigoutil.GetMcpServerStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'GetMcpServerStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetMcpServerAccessLevel: BridgeCommands.Command<
    Types.Nvapp.Nvigoutil.SetMcpServerAccessLevelParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvIGOUtil',
    method: 'SetMcpServerAccessLevel',
    persistent: false
};

export const Nvigoutil = {
ToggleIGO,
GetShadowPlaySupported,
GetShadowPlayStatus,
GetFilterPhotoModeState,
SetFilterPhotoMode,
SetGAssistInstall,
OpenIGO,
GetHotkeyShortcut,
SetNvAppReadyForGAssist,
ToggleMcpServer,
GetMcpServerStatus,
SetMcpServerAccessLevel
};
